"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation"; // Import usePathname
import * as CookieConsent from "vanilla-cookieconsent";
import { SERVICES_CONFIG } from "@/components/consent/config";

// Re-export for CookieConsent component
export { SERVICES_CONFIG };

export function useIframeManager() {
  const pathname = usePathname(); // Get the current URL path

  useEffect(() => {
    // This function gets the manager instance, resets it, and runs it.
    const initIframeManager = () => {
      if (typeof window !== "undefined" && typeof window.iframemanager === "function") {
        const im = window.iframemanager();

        // 1. Reset the manager to clear previous state and observers.
        // The `true` flag performs a "hard reset", cleaning up DOM elements.
        im.reset(true);

        // 2. Run the manager again with your configuration.
        im.run({
          onChange: ({
            changedServices,
            eventSource,
          }: {
            changedServices: string[];
            eventSource: { type: string; action: string };
          }) => {
            if (eventSource.type === "click") {
              changedServices.forEach((service) => {
                if (eventSource.action === "accept") {
                  CookieConsent.acceptService(service, "third");
                }
              });
            }
          },
          currLang: "ja",
          services: SERVICES_CONFIG,
        });
      }
    };

    // We use a short timeout to ensure Next.js has finished rendering
    // the new page's DOM before we try to scan it.
    const timer = setTimeout(initIframeManager, 100);

    // The cleanup function is crucial. It should also reset the manager
    // when the component unmounts.
    return () => {
      clearTimeout(timer);
      if (typeof window !== "undefined" && typeof window.iframemanager === "function") {
        const im = window.iframemanager();
        im.reset(true);
      }
    };
  }, [pathname]); // The key change: re-run this effect whenever the pathname changes.
}